import { z } from 'zod';

export const StaffPermissionGroupItemSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  scopeType: z.literal('SYSTEM'),
});

export type StaffPermissionGroupItem = z.infer<typeof StaffPermissionGroupItemSchema>;

export const ListStaffPermissionGroupsResponseSchema = z.object({
  items: z.array(StaffPermissionGroupItemSchema),
});

export type ListStaffPermissionGroupsResponse = z.infer<
  typeof ListStaffPermissionGroupsResponseSchema
>;
